import { render, staticRenderFns } from "./SubCategory.vue?vue&type=template&id=5e23af0a"
import script from "./SubCategory.vue?vue&type=script&lang=js"
export * from "./SubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports